module.exports = __webpack_public_path__ + "img/155.b65a9e28.png";